import { useState } from "react";

export default function RoleListTable() {
  const [search, setSearch] = useState("");

  return (
    <div className="ad-card ad-card-lg ad-animate">

      {/* Header */}
      <div className="ad-card-header">
        <h5 className="ad-card-title">Role List</h5>

        <div className="ad-search-wrap">
          <span className="ad-search-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </span>
          <input
            type="text"
            className="ad-search-input"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/* Table */}
      <div className="ad-table-scroll">
        <table className="ad-table">
          <thead>
            <tr>
              <th>Company</th>
              <th>Role Name</th>
              <th>Created Date</th>
              <th style={{ textAlign: "center" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={4}>
                <div className="ad-empty">
                  <svg className="ad-empty-icon" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M9 17H7A5 5 0 0 1 7 7h2" />
                    <path d="M15 7h2a5 5 0 0 1 0 10h-2" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                  </svg>
                  <p className="ad-empty-title">No Data Found</p>
                  <p className="ad-empty-sub">No roles have been created yet.</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  );
}